import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { publicAPI } from '../../services/api';
import '../Marcas/BrandProducts.css'; // Reutilizamos los estilos de productos

const SearchResults = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q');
  const [products, setProducts] = useState([]);
  const [brands, setBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    publicAPI.getBrands()
      .then(response => setBrands(response.data))
      .catch(console.error);
  }, []);

  useEffect(() => {
    const fetchResults = async () => {
      setLoading(true);
      try {
        // Pasamos null como brandId y el query como search
        const response = await publicAPI.getProducts(selectedBrand || null, query);
        setProducts(response.data);
      } catch (error) {
        console.error('Error searching products:', error);
      } finally {
        setLoading(false);
      }
    };

    if (query) {
      fetchResults();
    } else {
      setProducts([]);
      setLoading(false);
    }
  }, [query, selectedBrand]);

  if (loading) return <div className="loading">Buscando...</div>;

  return (
    <div className="brand-products-page" style={{ color: 'rgb(116, 70, 49)' }}>
      <div className="container">
        <section className="hero-section" style={{ background: 'rgb(116, 70, 49)', color: 'white', padding: '3rem 0', marginBottom: '3rem', textAlign: 'center' }}>
          <h1>
            Resultados para: "{query}" <span style={{ fontSize: '0.6em', color: '#6b7280', marginLeft: '10px' }}>({products.length})</span>
          </h1>
        </section>
        
        <div className="results-header" style={{ marginBottom: '2rem' }}>
          
          <div className="filters">
            <select 
              value={selectedBrand} 
              onChange={(e) => setSelectedBrand(e.target.value)}
              className="brand-select"
            >
              <option value="">Todas las marcas</option>
              {brands.map(brand => (
                <option key={brand.id} value={brand.id}>{brand.name}</option>
              ))}
            </select>
          </div>
        </div>
        
        {products.length === 0 ? (
          <div className="no-products">
            <p>No se encontraron productos que coincidan con tu búsqueda.</p>
            <Link to="/marcas" className="back-btn" style={{marginTop: '1rem'}}>Ver todas las marcas</Link>
          </div>
        ) : (
          <div className="products-grid">
            {products.map((product) => (
              <div key={product.id} className="product-card">
                <div className="product-image-container">
                  {product.image_path ? (
                    <img 
                      src={product.image_path} 
                      alt={product.name} 
                      className="product-image" 
                    />
                  ) : (
                    <div className="no-image-placeholder">Sin Imagen</div>
                  )}
                </div>
                <div className="product-info">
                  <h3>{product.name}</h3>
                  <p className="product-description">{product.description}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchResults;
